import { gql, QueryHookOptions, useQuery } from '@apollo/client';

import { GetBeforeAndAfterPhotosForMaintenanceRequest } from '../../../athena/types/GetBeforeAndAfterPhotosForMaintenanceRequest';
import { WebPhotoFields } from '../../../fragments/web/WebPhotoFields';

export const GET_BEFORE_AND_AFTER_PHOTOS_FOR_MAINTENANCE_REQUEST = gql`
  query GetBeforeAndAfterPhotosForMaintenanceRequest($requestId: String!) {
    webMaintenance {
      getBeforeAndAfterPhotos(input: { maintenanceRequestId: $requestId }) {
        beforePhotos {
          ...WebPhotoFields
        }
        afterPhotos {
          ...WebPhotoFields
        }
      }
    }
  }
  ${WebPhotoFields}
`;

const useGetBeforeAndAfterPhotosForMaintenanceRequest = (
  options?: QueryHookOptions<GetBeforeAndAfterPhotosForMaintenanceRequest>,
) =>
  useQuery<GetBeforeAndAfterPhotosForMaintenanceRequest>(
    GET_BEFORE_AND_AFTER_PHOTOS_FOR_MAINTENANCE_REQUEST,
    options,
  );

export default useGetBeforeAndAfterPhotosForMaintenanceRequest;
